import { render, staticRenderFns } from "./video-upload.vue?vue&type=template&id=0b1bc978&scoped=true&"
import script from "./video-upload.vue?vue&type=script&lang=js&"
export * from "./video-upload.vue?vue&type=script&lang=js&"
import style0 from "./video-upload.vue?vue&type=style&index=0&id=0b1bc978&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1bc978",
  null
  
)

export default component.exports